'use client';

import { Mail, Phone, GraduationCap } from 'lucide-react';
import Link from 'next/link';
import { APP_CONSTANTS } from '../../../constants/app.constants';

export default function HomeFooter() {
  return (
    <footer>
      {/* Main Footer Content */}
      <div className="px-4 sm:px-8 pt-12 sm:pt-16 lg:pt-20 pb-12 sm:pb-16 lg:pb-20">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12 lg:gap-16">
            {/* Left Column - Company Information */}
            <div>
              {/* Logo */}
              <div className="mb-4">
                <img src={APP_CONSTANTS.APP_LOGO_WITH_NAME} className="h-6 xs:h-7 sm:h-8 md:h-9 lg:h-10 w-auto" />
              </div>

              {/* Tagline */}
              <p className="text-sm sm:text-base text-[#4D4F52] mb-8 leading-relaxed max-w-xs sm:max-w-sm md:max-w-md">
                A modern school ERP that connects students, teachers, and administration with effortless efficiency.
              </p>

              {/* Contact Information */}
              <div className="space-y-4 mb-8">
                <div className="flex items-center gap-3">
                  <Mail className="h-5 w-5 text-[#4D4F52]" />
                  <span className="text-sm sm:text-base text-[#4D4F52]">
                    Email:{' '}
                    <a
                      href="mailto:nest-support@emmple.com"
                      className="text-[#10B981] hover:underline font-medium"
                    >
                      nest-support@emmple.com
                    </a>
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <Phone className="h-5 w-5 text-[#4D4F52]" />
                  <span className="text-sm sm:text-base text-[#4D4F52]">
                    Phone:{' '}
                    <a
                      href="tel:+917650963333"
                      className="text-[#10B981] hover:underline font-medium"
                    >
                      +91 7650-96-3333
                    </a>
                  </span>
                </div>
              </div>

              {/* Copyright */}
              <p className="text-xs sm:text-sm text-[#9CA3AF]">
              © 2024-2026 Nest ERP by Emmple (Wisflux Private Limited).
              </p>
            </div>

            {/* Middle Column - Quick Links */}
            <div>
              <h3 className="text-base sm:text-lg font-bold text-[#1D2125] uppercase tracking-wide mb-6">
                QUICK LINKS
              </h3>
              <nav className="flex flex-col gap-4">
                <Link
                  href="/"
                  className="text-sm sm:text-base text-[#4D4F52] hover:text-[#0D373D] transition-colors"
                >
                  Home
                </Link>
                <Link
                  href="/about"
                  className="text-sm sm:text-base text-[#4D4F52] hover:text-[#0D373D] transition-colors"
                >
                  About
                </Link>

                <Link
                  href="/features"
                  className="text-sm sm:text-base text-[#4D4F52] hover:text-[#0D373D] transition-colors"
                >
                  Features
                </Link>

                <Link
                  href="/contact-us"
                  className="text-sm sm:text-base text-[#4D4F52] hover:text-[#0D373D] transition-colors"
                >
                  Contact Us
                </Link>
                <Link
                  href="/privacy-policy"
                  className="text-sm sm:text-base text-[#4D4F52] hover:text-[#0D373D] transition-colors"
                >
                  Privacy Policy
                </Link>
              </nav>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Section - Powered by */}
      <div className="border-t border-[#E5E7EB] px-4 sm:px-8 py-6">
        <div className="max-w-6xl mx-auto text-center">
          <div className="flex items-center justify-center gap-2">
            <span className="text-sm text-[#1D2125]">Powered by</span>
            <div className="flex items-center gap-2">
              <img
                src={APP_CONSTANTS.ASSETS.emmpleLogo}
                className="w-24 h-10"
              />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}


